var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discovery"},[_c('Banner',{attrs:{"pic-list":_vm.picList}}),_c('dailySongList',{attrs:{"daily-songlist":_vm.dailySongList}}),_c('newSongs',{attrs:{"new-song":_vm.newsong}}),_c('rcmMv',{attrs:{"rcm-mv":_vm.rcmMv}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }